import { useEffect } from 'react';
import type { To } from 'react-router-dom';
import { useMatch } from 'react-router-dom';

import { useFeatureFlags } from './useFeatureFlags';
import { STORAGE, useInMemoryStorage } from './useInMemoryStorage';

export const useContextNavigation = ({ to }: { to?: To }) => {
  const {
    flags: { useContextModeNavigation = false },
  } = useFeatureFlags();
  const [savedHistory, setSavedHistory] = useInMemoryStorage<
    Record<string, string>
  >(STORAGE.savedHistory, {});
  const enabledContextModeNavigation = useContextModeNavigation && to;
  const { pathnameBase } = useMatch(`${to}/*`) || {};
  const { params } = useMatch(`${to}/:subpath/*`) || {};
  const savedItem = typeof to === 'string' && savedHistory?.[to];

  useEffect(() => {
    if (
      typeof to === 'string' &&
      params?.subpath &&
      savedHistory[to] !== `${to}/${params.subpath}`
    ) {
      setSavedHistory(saved => ({ ...saved, [to]: `${to}/${params.subpath}` }));
    }
  });

  if (enabledContextModeNavigation && savedItem && !pathnameBase) {
    return savedItem;
  }
  return undefined;
};
